import React, { useEffect, useState } from 'react';
import {
  Fab,
  TextareaAutosize,
  Typography,
  withStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '../styles';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';
import { getChatGroup } from '~/store/dispatch/actions';
import {
  Card, CardHeader, CardBody, CardIcon,
} from '~/components/Card';
import { setSuccessToastMessage } from '~/store/errors/actions';

const SendGroupMessageModal = ({ handleClose }) => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  const [dataLoaded, setDataLoaded] = useState(false);
  const [groupMessage, setGroupMessage] = useState('');
  const [selectedGroup, setSelectedGroup] = useState(0);

  const chatGroups = useSelector(s => s.dispatch.chatGroups);
  const socket = useSelector(state => state.chat.socketConnection);
  const platformUser = useSelector(state => state.auth.user);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getChatGroup());
    };

    if (!dataLoaded) {
      fetchData();
      setDataLoaded(true);
    }
  }, [dataLoaded, getChatGroup]);

  const renderHeader = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        backgroundColor: '#fff',
        paddingBlock: '1rem',
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        {translate('common:SendMessagesToGroup')}
      </Typography>
    </div>
  );

  const disableSaveButton = (
    groupMessage.length > 250 || groupMessage.length < 1 || selectedGroup === 0
  );

  const handleSendMessage = () => {
    const rooms = chatGroups.find(
      cg => cg.id === selectedGroup,
    ).equipments_id;

    const msgData = {
      message: groupMessage,
      rooms: JSON.parse(rooms),
      sender: {
        web_user_id: platformUser.id,
        operator_name: platformUser.username,
      },
    };

    socket.emit('platform_to_tablet_message_by_groups', msgData, () => {});

    setGroupMessage('');
    setSelectedGroup(0);
    dispatch(
      setSuccessToastMessage(
        translate('validation:GroupMessageSendSuccess'),
      ),
    );
  };

  const renderBody = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <TextareaAutosize
        style={{
          width: '300px',
          height: '200px',
          resize: 'none',
          border: '2px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxSizing: 'border-box',
        }}
        value={groupMessage}
        onChange={e => setGroupMessage(e.target.value)}
      />
      <Fab
        variant="extended"
        size="medium"
        color="secondary"
        onClick={() => handleSendMessage()}
        disabled={disableSaveButton}
      >
        {translate('common:SendMessage')}
      </Fab>
    </div>
  );

  return (
    <div>
      <Card>
        <CardHeader icon>
          <CardIcon
            onClick={handleClose}
            style={{
              float: 'right',
              cursor: 'pointer',
              background: 'darkgray',
              borderRadius: 50,
              boxShadow: '10px 10px 50px gray',
              marginRight: 0,
            }}
          >
            <CloseIcon />
          </CardIcon>
        </CardHeader>
        <CardBody>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              padding: '10px',
            }}
          >
            {renderHeader()}
            <hr style={{ margin: '0px' }} />
            <PF2MSearchSelectOutlined
              value={selectedGroup}
              onChange={e => setSelectedGroup(e.target.value)}
            >
              {[{ value: 0, label: translate('common:Select') }].concat(
                chatGroups
                  .filter(cg => cg.active === 1)
                  .map(cg => ({ value: cg.id, label: cg.name })),
              )}
            </PF2MSearchSelectOutlined>
            <hr style={{ margin: '0px' }} />
            {renderBody()}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

SendGroupMessageModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(SendGroupMessageModal);
